import { CheckAuthAndRedirect } from "@/widgets/check-auth-and-redirect";
import { ShowCaughtErrorUi } from "@/widgets/show-caught-error/ui";
import { CatchBoundary, Outlet, createRootRoute } from "@tanstack/react-router";
import * as React from "react";

const TanStackRouterDevtools =
  import.meta.env.VITE_APP_ENV === "production"
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

export const Route = createRootRoute({
  component: () => (
    <CatchBoundary
      getResetKey={() => "root"}
      errorComponent={({ error }) => <ShowCaughtErrorUi error={error} />}
    >
      <Outlet />
      <React.Suspense>
        <TanStackRouterDevtools />
      </React.Suspense>
    </CatchBoundary>
  ),
  notFoundComponent: () => <CheckAuthAndRedirect pathNotFound />,
});
